import { PAGES_ROUTES } from '../Constants/PagesRoutes'

const EVENT_ROUTE_MAP: { match: (eventCode: string) => boolean; subRoute: string }[] = [
  {
    match: (eventCode) => eventCode === 'bulk.state.change',
    subRoute: PAGES_ROUTES.BulkStateListing,
  },
  {
    match: (eventCode) => eventCode.includes('asset.ops'),
    subRoute: PAGES_ROUTES.AssetOps,
  },
]

export const MODULE_ROUTE_MAP: Record<string, string> = {
  widget: PAGES_ROUTES.ManageWidget,
  container: PAGES_ROUTES.ManageContainer,
  sitenavigation: PAGES_ROUTES.SiteNavigation,
  bulkoperation: PAGES_ROUTES.BulkOperation,
}

export const getNotificationRoute = (notification: {
  eventCode?: string
  module?: string
  payload?: { contentDocId?: string }
}): string | null => {
  const module = (notification?.module || '').toLowerCase()
  const baseRoute = MODULE_ROUTE_MAP[module]

  if (!baseRoute) return null

  const eventCode = notification?.eventCode || ''

  for (const entry of EVENT_ROUTE_MAP) {
    if (entry.match(eventCode)) {
      return `/${baseRoute}/${entry.subRoute}`
    }
  }

  const contentDocId = notification?.payload?.contentDocId
  if (contentDocId) {
    return `/${baseRoute}/${PAGES_ROUTES.PageTypeView}/${contentDocId}`
  }

  return null
}
